import React, { useEffect, useState } from "react";
import Diagrama, { disponer, pasosDe } from "../Diagrama";
import { nodoFallaDefecto, textoFalla } from "../utilGuia";

const reducido = () => { try { return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches); } catch (e) { return false; } };

// Diagrama animado con sus controles (anterior / pausar / siguiente), la lista de pasos (si hay) y la simulacion de fallas con clic en una pieza.
// Lo usan las lecciones, el constructor y las simples; la pagina principal tiene su propia version porque ademas resalta objetos.
//   pasos   textos de cada paso (opcional)         falla  { nodo, texto } redactada para una pieza (opcional)
const CuadroDiagrama = ({ patron = "libre", nodos, flujos, grupo, grupos, color = "#8C4FFF", pasos, falla, permitirFalla = true, titulo, extra }) => {
    const total = pasos ? pasos.length : pasosDe(patron, nodos.length, flujos);
    const [paso, setPaso] = useState(0);
    const [pausado, setPausado] = useState(reducido());
    const [simular, setSimular] = useState(false);
    const [caido, setCaido] = useState(null);
    useEffect(() => { setPaso(0); }, [total]);
    useEffect(() => { setSimular(false); setCaido(null); }, [nodos]);
    useEffect(() => {
        if (pausado || total < 2) return undefined;
        const t = setInterval(() => setPaso(p => (p + 1) % total), 3200);
        return () => clearInterval(t);
    }, [pausado, total]);

    const dibujo = { patron, nodos, flujos, falla };
    const nodoCaido = simular ? (caido != null && caido < nodos.length ? caido : nodoFallaDefecto({ ...dibujo, patron })) : null;
    const hayFlechas = disponer(patron, nodos.length, nodos, flujos).flujos.some(f => f.tramos.length);
    return (
        <div>
            <div className="d-flex align-items-center flex-wrap gap-2 mb-1">
                {titulo && <b className="me-auto">{titulo}</b>}
                {!titulo && <span className="me-auto" />}
                {permitirFalla && hayFlechas && (
                    <button className={`btn btn-sm no-imprimir ${simular ? "btn-danger" : "btn-outline-danger"}`} aria-pressed={simular} onClick={() => { setSimular(s => !s); setCaido(null); }}>
                        <i className="fa fa-bolt me-1" />{simular ? "Volver a la normalidad" : "¿Qué pasa si falla?"}
                    </button>
                )}
                {total > 1 && (
                    <div className="btn-group btn-group-sm no-imprimir">
                        <button className="btn btn-outline-secondary" onClick={() => { setPausado(true); setPaso(p => (p - 1 + total) % total); }} aria-label="Paso anterior"><i className="fa fa-step-backward" /></button>
                        <button className="btn btn-outline-secondary" onClick={() => setPausado(p => !p)} aria-label={pausado ? "Reanudar animación" : "Pausar animación"}><i className={`fa fa-${pausado ? "play" : "pause"}`} /> {pausado ? "Reproducir" : "Pausar"}</button>
                        <button className="btn btn-outline-secondary" onClick={() => { setPausado(true); setPaso(p => (p + 1) % total); }} aria-label="Paso siguiente"><i className="fa fa-step-forward" /></button>
                    </div>
                )}
            </div>
            <Diagrama patron={patron} nodos={nodos} flujosLibres={flujos} grupo={grupo} grupos={grupos} color={color} paso={paso} fallo={nodoCaido} pausado={pausado} onNodo={simular ? setCaido : undefined} />
            {simular && nodoCaido != null && (
                <div className="alert alert-danger py-2 small mt-2 mb-2" role="status">
                    <b><i className="fa fa-bolt me-1" />Simulación:</b> {textoFalla(dibujo, nodoCaido)}
                    <div className="text-muted mt-1">Pulsa otra pieza para ver qué pasa si es esa la que falla.</div>
                </div>
            )}
            {pasos && (
                <ol className="list-unstyled mt-2 mb-0">
                    {pasos.map((t, k) => (
                        <li key={k} className={`d-flex align-items-start p-2 rounded mb-1 ${k === paso ? "border" : ""}`}
                            style={{ cursor: "pointer", background: k === paso ? `${color}1f` : "transparent", borderColor: color }} onClick={() => { setPausado(true); setPaso(k); }}>
                            <span className="badge rounded-pill me-2 mt-1" style={{ background: color }}>{k + 1}</span><span>{t}</span>
                        </li>
                    ))}
                </ol>
            )}
            {extra}
        </div>
    );
};

export default CuadroDiagrama;
